import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography, Link, Box } from "@material-ui/core";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import FolderIcon from "@material-ui/icons/Folder";

const useStyles = makeStyles((theme) => ({
  root: {},
  docstructicon: {
    "& > svg": {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      fontSize: 32,
    },
  },
}));

const DocumentStructNameSelectOnly = ({ document, openDocumentHandler, ...rest }) => {
  const classes = useStyles();

  let icon;
  let nameLink;

  if (document.nodeType === "1") {
    icon = (
      <div className={classes.docstructicon}>
        <SvgIcon>
          <FolderIcon />
        </SvgIcon>
      </div>
    );
    nameLink = (
      <Typography color="textPrimary" variant="body1">
        <Link href="#" onClick={(e) => openDocumentHandler(e, document.id)}>
          {document.name}
        </Link>
      </Typography>
    );
  } else {
    icon = (
      <div className={classes.docstructicon}>
        <SvgIcon>
          <FileIcon
            extension={document.fileType}
            {...defaultStyles[document.fileType]}
          />
        </SvgIcon>
      </div>
    );
    nameLink = (
      <Typography color="textPrimary" variant="body1">
          {document.name}
      </Typography>
    );
  }

  return (
    <Box alignItems="center" display="flex" height="2%">
      {icon}
      {nameLink}
    </Box>
  );
};

document.propTypes = {
  className: PropTypes.object,
};

export default DocumentStructNameSelectOnly;
